/* eslint-disable */
// @ts-nocheck
import dash_api from '../support/dash_api';
import { ReduxAsyncAction } from '../support/utils';

const QuickLinkTemplates = new ReduxAsyncAction('GET_QUICK_LINK_TEMPLATES');
QuickLinkTemplates.registerRequest(function (pagesize: number) {
  return dash_api.get(`/v1/linkhub/quick-link-templates`, { params: { pagesize: pagesize } }).then(({ data }) => {
    return data;
  });
});
export const getQuickLinkTemplates = QuickLinkTemplates.request;
export const GET_QUICK_LINK_TEMPLATES: any = QuickLinkTemplates.constants;
